/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LlmStreamCompletedMessage } from '../../models/llm-stream-completed-message';

export interface GetnotificationsLlmStreamCompletedSchema$Params {
}

export function getnotificationsLlmStreamCompletedSchema(http: HttpClient, rootUrl: string, params?: GetnotificationsLlmStreamCompletedSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<LlmStreamCompletedMessage>> {
  const rb = new RequestBuilder(rootUrl, getnotificationsLlmStreamCompletedSchema.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LlmStreamCompletedMessage>;
    })
  );
}

getnotificationsLlmStreamCompletedSchema.PATH = '/api/hubs/notifications/LlmStreamCompleted';
